if (!customElements.get('gift-wrap')) {
  class GiftWrap extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      const label  = this.querySelector('label.gift-wrap-checker');
      const checkbox = label?.querySelector('input[gift-wrap]');
      const productId = checkbox?.getAttribute("giftwrap-variant");
      const cartDrawerForm = document.querySelector('#cart-drawer-form');
      const cart = await this.getCart();

      const giftWrapInCart = this.isGiftInCart(cart?.items, productId);

      giftWrapInCart ? checkbox.checked = true : checkbox.checked = false;

      label.addEventListener('click', () => this.handleLabelClick(checkbox, productId, cartDrawerForm) );
    }

    async getCart() {
      const response = await fetch("/cart.js", {
        method: "GET",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
      });
    
      return response.json();
    }

    isGiftInCart(items, productId) {
      if (!items || !Array.isArray(items) || items.length === 0 || !productId) {
        console.warn('❌ No items found');
        return false;
      }
      return items.some(item => item.id.toString() === productId);
    }

    async handleLabelClick(checkbox, productId, cartDrawerForm) {
      if (!checkbox || !productId || !cartDrawerForm) {
        console.warn('❌ No checkbox or productId or cartDrawerForm found');
        return; 
      }
      
      checkbox.disabled = true;
      checkbox.checked = !checkbox.checked;

      // Update cart when gift wrap is clicked
      cartDrawerForm.classList.add('loading');

      if (checkbox.checked) await this.addProductToCart(productId) 
      else await this.removeProductFromCart(productId);
      
      await this.updateCartTotal();
      cartDrawerForm.classList.remove('loading');
      checkbox.disabled = false;
    }

    async updateCartTotal() {
      const updatedCart = await this.getCart();
      const format = window.theme.settings.money_with_currency_format;
      const cartTotalPrice = formatMoney(updatedCart.total_price, format);

      const totalEl = document.querySelector("#cart-drawer-total");
      if (totalEl) totalEl.textContent = `${cartTotalPrice}`;
    }

    async addProductToCart(id) {
      if (!id) return;

      return await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: id,
              quantity: 1,
            },
          ],
        }),
      });
    }

    async removeProductFromCart(id) {
      if (!id) return;

      return await fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          quantity: 0,
        }),
      });
    }
  }

  customElements.define('gift-wrap', GiftWrap);
}